import { useGetAccountTimeZoneQuery } from '../../../../../redux/api/fymAPI';
import { useAccountId } from '../../../../../redux/slices/appInfo/hooks';

/**
 * The stored time zone of the active artist (Settings → Artist → Time zone), or null when the
 * artist has none yet or it is still loading. The one-off publish uses it for "On release day";
 * with null it falls back to the zone of this browser.
 */
export function useArtistTimeZone(): string | null {
  const accountId = useAccountId();
  const { data } = useGetAccountTimeZoneQuery({ accountId: accountId ?? 0 }, { skip: accountId === null });
  return data?.timeZone ?? null;
}
